import type aiEn from "./ai.en";

const aiAr: Record<keyof typeof aiEn, string> = {
  "ai.title": "مساعد التصميم بالذكاء الاصطناعي",
  "ai.open": "مساعد الذكاء الاصطناعي",
  "ai.close": "إغلاق المساعد",
  "ai.write_with_ai": "الكتابة بالذكاء الاصطناعي",
  "ai.credits_left": "تبقّى {n} رصيد هذا الشهر",
  "ai.credits_today": "تبقّى {n} اليوم",
  "ai.off_no_key": "مساعد الذكاء الاصطناعي غير مُفعّل على المنصة بعد.",
  "ai.off": "مساعد الذكاء الاصطناعي غير متاح لمتجرك حالياً.",
  "ai.out_of_credits": "استخدمت رصيد الذكاء الاصطناعي لهذا الشهر. يتجدد في {date}.",
  "ai.pick_theme": "القالب الذي سيُعدَّل",
  "ai.no_theme": "المحتوى فقط (دون تغيير القالب)",
  "ai.theme_live": "{name} (المنشور)",
  "ai.placeholder": "اطلب تعديلاً: «اجعل البانر أغمق»، «أضف قسماً لعروض رمضان»، «اكتب أوصافاً عربية لعباءاتي»…",
  "ai.send": "إرسال",
  "ai.stop": "إيقاف",
  "ai.stopping": "جارٍ الإيقاف…",
  "ai.new_chat": "محادثة جديدة",
  "ai.history": "محادثات سابقة",
  "ai.empty_intro": "أخبر المساعد بما تريد تغييره في متجرك. يُعدّ التغييرات في مسودة؛ تعاينها ثم تطبّقها عندما تكون راضياً.",
  "ai.disclaimer": "قد يخطئ الذكاء الاصطناعي. راجع التغييرات قبل تطبيقها.",
  "ai.selected": "{count, plural, zero {لم يُحدَّد أي منتج} one {منتج واحد محدد} two {منتجان محددان} few {# منتجات محددة} many {# منتجاً محدداً} other {# منتج محدد}}",
  "ai.working": "جارٍ العمل…",
  "ai.thinking": "جارٍ التخطيط…",
  "ai.step.understanding": "فهم طلبك",
  "ai.step.planning": "تخطيط العمل",
  "ai.step.get_store_profile": "قراءة إعدادات متجرك",
  "ai.step.get_theme_contract": "قراءة القالب",
  "ai.step.list_template_sections": "قراءة الصفحة",
  "ai.step.read_theme_file": "قراءة ملف من القالب",
  "ai.step.get_locale_strings": "قراءة نصوص القالب",
  "ai.step.list_products": "استعراض المنتجات",
  "ai.step.get_product": "قراءة منتج",
  "ai.step.list_collections": "استعراض المجموعات",
  "ai.step.get_collection": "قراءة مجموعة",
  "ai.step.list_pages": "استعراض الصفحات",
  "ai.step.get_page": "قراءة صفحة",
  "ai.step.analyze_image": "فحص صورة",
  "ai.step.run_seo_audit": "فحص تحسين محركات البحث",
  "ai.step.set_theme_settings": "تغيير إعدادات القالب",
  "ai.step.apply_preset": "تطبيق نمط للقالب",
  "ai.step.add_section": "إضافة قسم",
  "ai.step.update_section_settings": "تعديل قسم",
  "ai.step.move_section": "نقل قسم",
  "ai.step.remove_section": "حذف قسم",
  "ai.step.add_block": "إضافة عنصر",
  "ai.step.remove_block": "حذف عنصر",
  "ai.step.create_custom_section": "إنشاء قسم جديد",
  "ai.step.set_locale_strings": "تعديل نصوص القالب",
  "ai.step.update_product_content": "كتابة محتوى المنتج",
  "ai.step.update_collection_content": "كتابة محتوى المجموعة",
  "ai.step.update_page_content": "كتابة محتوى الصفحة",
  "ai.step.update_image_alt": "كتابة النص البديل للصورة",
  "ai.step.update_home_seo": "كتابة بيانات البحث للصفحة الرئيسية",
  "ai.step.validate_changeset": "التحقق من التغييرات",
  "ai.step.render_preview": "معاينة الصفحة",
  "ai.step.ask_merchant": "سؤالك",
  "ai.step.finish": "إنهاء العمل",
  "ai.status.queued": "المساعد مشغول؛ طلبك هو التالي…",
  "ai.status.batch": "{count, plural, zero {لا عناصر للكتابة} one {جارٍ كتابة عنصر واحد في الخلفية} two {جارٍ كتابة عنصرين في الخلفية} few {جارٍ كتابة # عناصر في الخلفية} many {جارٍ كتابة # عنصراً في الخلفية} other {جارٍ كتابة # عنصر في الخلفية}}. سنُعلمك عند الانتهاء؛ يمكنك إغلاق هذه اللوحة.",
  "ai.status.waiting": "بانتظار إجابتك",
  "ai.status.budget": "توقّف عند حدّ هذه المهمة",
  "ai.status.failed": "حدث خطأ ما",
  "ai.status.cancelled": "تم الإيقاف",
  "ai.changes_title": "التغييرات",
  "ai.changes_none": "لم تُجرَ أي تغييرات.",
  "ai.preview_note": "تغييرات القالب تظهر في معاينة المحرر. تغييرات المحتوى تُنشر عند التطبيق.",
  "ai.apply": "تطبيق",
  "ai.discard": "تجاهل",
  "ai.undo": "تراجع",
  "ai.applied": "تم التطبيق",
  "ai.applied_toast": "تم تطبيق التغييرات",
  "ai.discarded": "تم التجاهل",
  "ai.undone": "تم التراجع",
  "ai.undone_toast": "تم التراجع عن التغييرات",
  "ai.show_details": "عرض التفاصيل",
  "ai.hide_details": "إخفاء التفاصيل",
  "ai.before": "قبل",
  "ai.after": "بعد",
  "ai.include": "تضمين",
  "ai.new_section_file": "ملف قسم جديد",
  "ai.conflicts_title": "تغيّر بعد عمل المساعد عليه",
  "ai.conflicts_body": "غيّر أحدهم هذه بعد المساعد. اختر النسخة التي تريد الإبقاء عليها لكل منها.",
  "ai.keep_ai": "استخدام نسخة المساعد",
  "ai.keep_mine": "الإبقاء على التغيير الآخر",
  "ai.apply_resolved": "تطبيق",
  "ai.invalid_changes": "ما زالت في التغييرات مشكلات. اطلب من المساعد إصلاحها أو تجاهلها.",
  "ai.estimate_title": "هذه مهمة أكبر",
  "ai.estimate_body": "تستخدم {credits} رصيد كحدٍّ أقصى (تبقّى {left} هذا الشهر).",
  "ai.estimate_background": "تعمل في الخلفية وبتكلفة أقل.",
  "ai.estimate_confirm": "متابعة",
  "ai.cancel": "إلغاء",
  "ai.feedback_up": "نتيجة جيدة",
  "ai.feedback_down": "غير مفيد",
  "ai.feedback_comment": "ما الذي يمكن تحسينه؟ (اختياري)",
  "ai.feedback_thanks": "شكراً على ملاحظاتك",
  "ai.feedback_send": "إرسال",
  "ai.suggest.home_meta_missing": "اكتب العنوان والوصف التعريفي لصفحتي الرئيسية",
  "ai.suggest.product_meta_missing": "{count, plural, zero {لا منتجات بلا بيانات بحث} one {اكتب بيانات البحث لمنتج واحد ينقصه ذلك} two {اكتب بيانات البحث لمنتجين ينقصهما ذلك} few {اكتب بيانات البحث لـ # منتجات ينقصها ذلك} many {اكتب بيانات البحث لـ # منتجاً ينقصه ذلك} other {اكتب بيانات البحث لـ # منتج ينقصه ذلك}}",
  "ai.suggest.product_description_thin": "{count, plural, zero {لا منتجات بأوصاف قصيرة} one {اكتب وصفاً أوفى لمنتج واحد وصفه قصير} two {اكتب أوصافاً أوفى لمنتجين وصفهما قصير} few {اكتب أوصافاً أوفى لـ # منتجات أوصافها قصيرة} many {اكتب أوصافاً أوفى لـ # منتجاً أوصافه قصيرة} other {اكتب أوصافاً أوفى لـ # منتج أوصافه قصيرة}}",
  "ai.suggest.arabic_missing": "{count, plural, zero {كل المنتجات لها نسخة عربية} one {اكتب العنوان والوصف بالعربية لمنتج واحد} two {اكتب العناوين والأوصاف بالعربية لمنتجين} few {اكتب العناوين والأوصاف بالعربية لـ # منتجات} many {اكتب العناوين والأوصاف بالعربية لـ # منتجاً} other {اكتب العناوين والأوصاف بالعربية لـ # منتج}}",
  "ai.suggest.image_alt_missing": "{count, plural, zero {كل الصور لها نص بديل} one {أضف نصاً بديلاً لصورة واحدة} two {أضف نصاً بديلاً لصورتين} few {أضف نصاً بديلاً لـ # صور} many {أضف نصاً بديلاً لـ # صورة} other {أضف نصاً بديلاً لـ # صورة}}",
  "ai.suggest.collection_meta_missing": "{count, plural, zero {كل المجموعات لها بيانات بحث} one {اكتب بيانات البحث لمجموعة واحدة} two {اكتب بيانات البحث لمجموعتين} few {اكتب بيانات البحث لـ # مجموعات} many {اكتب بيانات البحث لـ # مجموعة} other {اكتب بيانات البحث لـ # مجموعة}}",
  "ai.suggest.theme_darker": "اجعل مظهر المتجر أكثر فخامة",
  "ai.suggest.theme_offers": "أضف قسماً لعروض رمضان إلى الصفحة الرئيسية",
};

export default aiAr;
